import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from 'widgets/Button';
import { FormattedMessage } from 'react-intl';
import Loader from 'components/Loader';
import { changeSubscriptionActivateFields, clickSubscriptionActivateAddressDetailsButton } from 'libs/cleverTap';
import AddressForm from './AddressForm';
import styles from './style';
import {
  ADDRESS_INFO_KEYS, ERROR_INFO_KEYS,
  BILLING_ADDRESS_ERROR_CONFIG,
  checkErrors,
} from './config';
import SectionHeader from '../SectionHeader';
import './AddressDetails.scss';

const addressInfoKeys = {
  [ADDRESS_INFO_KEYS.FIRST_NAME]: '',
  [ADDRESS_INFO_KEYS.LAST_NAME]: '',
  [ADDRESS_INFO_KEYS.ADDRESS]: '',
  [ADDRESS_INFO_KEYS.APARTMENT]: '',
  [ADDRESS_INFO_KEYS.PHONE_NUMBER]: '',
  [ADDRESS_INFO_KEYS.COUNTRY]: { value: '', label: '' },
  [ADDRESS_INFO_KEYS.CITY]: '',
  [ADDRESS_INFO_KEYS.REGION]: { value: '', label: '' },
  [ADDRESS_INFO_KEYS.ZIP_CODE]: ''
};

class AddressDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      billingAddressInfo: { ...addressInfoKeys },
      errorInfo: {
        [ERROR_INFO_KEYS.BILLING_ADDRESS_FORM]: {},
        errorConfigBillingAddress: BILLING_ADDRESS_ERROR_CONFIG,
      },
    };
    this.isAddressFormDirty = false;
  }

  validateBillingAddressFields = (config = {}) => {
    this.props.closeErrorBar();
    const billingAddressInfo = { ...this.state.billingAddressInfo };

    const { errorInfo } = this.state;
    const { errorFieldsBilling, errorKeyBilling } = config;
    const errorsBillingAddress = checkErrors(errorFieldsBilling, billingAddressInfo);
    errorInfo[errorKeyBilling] = errorsBillingAddress;

    this.setState({
      errorInfo: {
        ...this.state.errorInfo,
        [ERROR_INFO_KEYS.BILLING_ADDRESS_FORM]: errorsBillingAddress,
      },
    });
    return errorInfo;
  }

  handleChangeBillingAddrZipCode = (e) => {
    const billingAddressInfo = { ...this.state.billingAddressInfo };
    billingAddressInfo[e.target.name] = e.target.value.toUpperCase();
    this.setState({ billingAddressInfo }, () => {
      if (this.isAddressFormDirty) {
        const { errorInfo: { errorConfigBillingAddress } } = this.state;
        this.validateBillingAddressFields(errorConfigBillingAddress);
      }
    });
    changeSubscriptionActivateFields(e.target.name); // track event
  }

  handleChangeBillingAddress = (e, cb) => {
    const billingAddressInfo = { ...this.state.billingAddressInfo };
    if (e.target.name === ADDRESS_INFO_KEYS.COUNTRY) {
      billingAddressInfo[ADDRESS_INFO_KEYS.REGION] = { value: '', label: '' };
    }
    billingAddressInfo[e.target.name] = e.target.value;
    this.setState({ billingAddressInfo }, cb);
    changeSubscriptionActivateFields(e.target.name); // track event
  }

  handleInputChangeBillingAddress = e => this.handleChangeBillingAddress(e, () => {
    if (this.isAddressFormDirty) {
      const { errorInfo: { errorConfigBillingAddress } } = this.state;
      this.validateBillingAddressFields(errorConfigBillingAddress);
    }
  });

  formatPhoneNumber = (event) => {
    let { value = '' } = event.target;
    const regex = /[^\d+]+$/;
    value = value.replace(regex, '');
    return value;
  }

  handleChangeBillingAddrPhoneNumber = (e) => {
    e.target.value = this.formatPhoneNumber(e);
    this.handleInputChangeBillingAddress(e);
  }

  handleAddressFormSave = () => {
    const {
      errorInfo: { errorConfigBillingAddress },
    } = this.state;
    let errorBillingAddressInfo = {
      [ERROR_INFO_KEYS.BILLING_ADDRESS_FORM]: {}
    };
    this.isAddressFormDirty = true;
    errorBillingAddressInfo = this.validateBillingAddressFields(errorConfigBillingAddress);

    if (Object.keys(errorBillingAddressInfo[ERROR_INFO_KEYS.BILLING_ADDRESS_FORM]).length) {
      return;
    }

    const billingAddress = _.cloneDeep(this.state.billingAddressInfo);
    const addressInfo = {
      shipping_address: billingAddress,
      billing_address: billingAddress
    };

    this.props.checkoutAddress(
      { addressInfo },
      this.handleSaveCallback
    );
    clickSubscriptionActivateAddressDetailsButton(); // track event
  }

  handleSaveCallback = ({
    message, isSuccess
  }) => {
    if (message) {
      this.props.showErrorBar({ message });
    }

    if (isSuccess) {
      this.props.checkoutSuccess();
    }
  }

  render() {
    const {
      errorInfo, billingAddressInfo
    } = this.state;
    const {
      currentSection, setCurrentSection,
      sectionHeader: { step, label, actionLabel },
      addressDetails: { info, isFetching },
      isActive, windowDimension
    } = this.props;
    const errorInfoBillingAddressForm = errorInfo[ERROR_INFO_KEYS.BILLING_ADDRESS_FORM] || {};

    return (
      <div className="SubscriptionActivate__AddressDetails">
        <div className="SubscriptionActivate__AddressDetails__Divider" />
        <SectionHeader
          step={step}
          label={label}
          isEdit={!!info}
          handleEdit={setCurrentSection}
          activeSection={currentSection}
          actionLabel={actionLabel}
          windowDimension={windowDimension}
        />
        {
          isFetching ?
            <div className="SubscriptionActivate__AddressDetails__Loader"><Loader /></div> :
            isActive &&
              <React.Fragment>
                <div className="SubscriptionActivate__AddressDetails__ContentWrap">
                  <div className="SubscriptionActivate__AddressDetails__ContentWrap__Text">
                    <FormattedMessage id="views.subscriptionActivate.addressDetails.contentWrap.text" />
                  </div>
                  <div className="SubscriptionActivate__AddressDetails__ContentWrap__Shipping">
                    <AddressForm
                      addressInfo={billingAddressInfo}
                      errorInfoAddressForm={errorInfoBillingAddressForm}
                      handleInputChange={this.handleInputChangeBillingAddress}
                      handleChangePhoneNumber={this.handleChangeBillingAddrPhoneNumber}
                      handleChangeZipCode={this.handleChangeBillingAddrZipCode}
                      handleAddressFormSave={this.handleAddressFormSave}
                    />
                  </div>
                  <div className="SubscriptionActivate__AddressDetails__ContentWrap__FormCard__Action">
                    <Button
                      id="SubscriptionActivate__AddressDetails__Action"
                      cssStyles={{
                        root: styles.AddressDetailsButtonStyle,
                        label: styles.AddressDetailsButtonLabelStyle,
                      }}
                      className="SubscriptionActivate__AddressDetails__ContentWrap__ActionButton"
                      onClick={this.handleAddressFormSave}
                    >
                      <FormattedMessage id="views.subscriptionActivate.addressDetails.actionButton.buttonLabel" />
                    </Button>
                  </div>
                </div>
              </React.Fragment>
        }
      </div>
    );
  }
}

AddressDetails.propTypes = {
  isActive: PropTypes.bool.isRequired,
  currentSection: PropTypes.string.isRequired,
  setCurrentSection: PropTypes.func.isRequired,
  sectionHeader: PropTypes.object.isRequired,
  addressDetails: PropTypes.object.isRequired,
  checkoutAddress: PropTypes.func.isRequired,
  windowDimension: PropTypes.object.isRequired,
  checkoutSuccess: PropTypes.func.isRequired
};

export default AddressDetails;



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AddressDetails/AddressDetails.jsx